function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.9193 0.509658C14.8204 0.178177 13.6552 0 12.4482 0C5.82083 0 0.448242 5.37258 0.448242 12C0.448242 18.6274 5.82083 24 12.4482 24C13.6552 24 14.8204 23.8218 15.9193 23.4903C13.1429 20.4646 11.4482 16.4302 11.4482 12C11.4482 7.5698 13.1429 3.5354 15.9193 0.509658Z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.9193 0.509658C14.8204 0.178177 13.6552 0 12.4482 0C5.82083 0 0.448242 5.37258 0.448242 12C0.448242 18.6274 5.82083 24 12.4482 24C13.6552 24 14.8204 23.8218 15.9193 23.4903C13.1429 20.4646 11.4482 16.4302 11.4482 12C11.4482 7.5698 13.1429 3.5354 15.9193 0.509658Z",
  fill: "#5D5D5D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9193 0.509658L16.6561 1.18575L17.7329 0.0122575L16.2081 -0.447727L15.9193 0.509658ZM15.9193 23.4903L16.2081 24.4477L17.7329 23.9877L16.6561 22.8142L15.9193 23.4903ZM12.4482 1C13.5563 1 14.6243 1.16351 15.6304 1.46704L16.2081 -0.447727C15.0166 -0.807157 13.7541 -1 12.4482 -1V1ZM1.44824 12C1.44824 5.92487 6.37311 1 12.4482 1V-1C5.26854 -1 -0.551758 4.8203 -0.551758 12H1.44824ZM12.4482 23C6.37311 23 1.44824 18.0751 1.44824 12H-0.551758C-0.551758 19.1797 5.26854 25 12.4482 25V23ZM15.6304 22.533C14.6243 22.8365 13.5563 23 12.4482 23V25C13.7541 25 15.0166 24.8072 16.2081 24.4477L15.6304 22.533ZM16.6561 22.8142C14.0423 19.9657 12.4482 16.1702 12.4482 12H10.4482C10.4482 16.6902 12.2434 20.9635 15.1824 24.1664L16.6561 22.8142ZM12.4482 12C12.4482 7.82984 14.0423 4.03427 16.6561 1.18575L15.1824 -0.166437C12.2434 3.03652 10.4482 7.30976 10.4482 12H12.4482Z",
  fill: "#5D5D5D",
  mask: "url(#path-1-inside-2)"
});

var SvgRating2 = function SvgRating2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRating2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Rating2.70180b8b.svg";
export { ForwardRef as ReactComponent };